import ContractActivityForm from '../forms/ContractActivityForm'
import {
  createContractActivity,
  clearContractActivityErrors,
  clearContractActivityAction,
} from 'actions/contracts/contractActivityActions'
import { fetchContractDocuments } from 'actions/contracts/contractDocumentActions'
import { fetchContractDocumentTypes } from 'actions/contracts/contractDocumentTypeActions'
import { useContractLocations } from 'hooks/api/useContractLocations'
import { useContractStatuses } from 'hooks/api/useContractStatuses'
import { useContractSublocations } from 'hooks/api/useContractSublocations'
import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const ContractActivityCreate = ({
  formId,
  contractId,
  params,
  setParams,
  closeModal,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, activityErrors } = useSelector(
    (state) => state.contractActivities
  )
  const documentTypeOptions = useSelector(
    (state) => state.contractDocumentTypes.documentTypeOptions
  )

  //// QUERIES.
  const { options: statusOptions } = useContractStatuses(
    params.contract_status_id
  )
  const { options: locationOptions } = useContractLocations(
    params.contract_location_id
  )
  const { options: sublocationOptions } = useContractSublocations(
    params.contract_location_id,
    params.contract_sublocation_id
  )

  //// LOCAL STATE.
  const [occurDate, setOccurDate] = useState(moment())
  const [occurTime, setOccurTime] = useState(moment())

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    dispatch(fetchContractDocumentTypes('form'))
    return () => {
      dispatch(clearContractActivityErrors())
      dispatch(clearContractActivityAction())
      dispatch(fetchContractDocuments({ contract_id: contractId }))
    }
  }, [dispatch, contractId])

  useEffect(() => {
    if (params.contract_location_id) {
      setParams((x) => ({ ...x, contract_sublocation_id: null }))
    }
  }, [dispatch, setParams, params.contract_location_id])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        contract_id: contractId,
        contract_status_id: '',
        contract_location_id: '',
        contract_sublocation_id: '',
        contract_document_type_id: '',
        comment: '',
        import_file: null,
        activity_occurred_at: moment().toISOString().split('.')[0],
      })
    }
  }, [contractId, params, setParams])

  // watch for success
  useEffect(() => {
    if (lastAction === 'create') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.

  return !_.size(params) ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        const activityParams = new FormData()
        activityParams.append('contract_id', params.contract_id)
        activityParams.append('contract_status_id', params.contract_status_id)
        activityParams.append(
          'contract_location_id',
          params.contract_location_id
        )
        activityParams.append(
          'contract_sublocation_id',
          params.contract_sublocation_id
        )
        activityParams.append(
          'activity_occurred_at',
          params.activity_occurred_at
        )
        activityParams.append('comment', params.comment)
        if (params.import_file) {
          activityParams.append('import_file', params.import_file)
          activityParams.append(
            'contract_document_type_id',
            params.contract_document_type_id
          )
        }

        dispatch(createContractActivity(activityParams, contractId))
      }}
      className="form container"
      noValidate
    >
      <ContractActivityForm
        params={params}
        setParams={setParams}
        statusOptions={statusOptions}
        locationOptions={locationOptions}
        sublocationOptions={sublocationOptions}
        documentTypeOptions={documentTypeOptions}
        occurDate={occurDate}
        setOccurDate={setOccurDate}
        occurTime={occurTime}
        setOccurTime={setOccurTime}
        errors={activityErrors}
      />
    </form>
  )
}

export default ContractActivityCreate
